/**
 * Component: Customers header
 * -----------------------------------------------------------------------------
 * Adds log out notification to customers header.
 *
 */
import timings from '~/config/timings'

/**
 * DOM selectors.
 */
const selectors = {
  logout: '[js-customers-header="logout"]',
}

/**
 * Create a new customers header object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    logout: document.querySelector(selectors.logout),
  }

  /**
   * Initialise component.
   */
  function init() {
    if (!nodeSelectors.logout) {
      return
    }

    setEventListeners()
  }

  /**
   * Set event listeners.
   */
  function setEventListeners() {
    if (!cnvs.settings.notifications.logout) {
      return
    }

    nodeSelectors.logout.addEventListener('click', async(event) => {
      event.preventDefault()

      cnvs.EventBus.emit('cnvs:set-notification', {
        displayUrl: cnvs.routes.root,
        text: cnvs.strings.customers.notifications.logout,
        timeout: timings.message,
        type: 'success',
      })

      await cnvs.Sleep(0)
      location.href = event.target.href
    })
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
